"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useHoverStatus;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useHoverStatus(_ref) {
  var targetRef = _ref.targetRef;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHover = _useState2[0],
    setIsHover = _useState2[1];
  var handleMouseOver = (0, _react.useCallback)(function () {
    return setIsHover(true);
  }, []);
  var handleMouseOut = (0, _react.useCallback)(function () {
    return setIsHover(false);
  }, []);
  (0, _react.useEffect)(function () {
    var targetDom = targetRef.current;
    if (targetDom) {
      targetRef.current.addEventListener('mouseover', handleMouseOver);
      targetRef.current.addEventListener('mouseout', handleMouseOut);
    }
    return function () {
      targetDom === null || targetDom === void 0 || targetDom.removeEventListener('mouseover', handleMouseOver);
      targetDom === null || targetDom === void 0 || targetDom.removeEventListener('mouseout', handleMouseOut);
    };
  }, [targetRef, handleMouseOver, handleMouseOut]);
  return {
    isHover: isHover
  };
}